"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Connect", {
  enumerable: true,
  get: function () {
    return _criteriaConnect.default;
  }
});
Object.defineProperty(exports, "Criteria", {
  enumerable: true,
  get: function () {
    return _criteria.default;
  }
});
Object.defineProperty(exports, "Header", {
  enumerable: true,
  get: function () {
    return _criteriaHeader.default;
  }
});
Object.defineProperty(exports, "Rule", {
  enumerable: true,
  get: function () {
    return _criteriaRule.default;
  }
});
exports.default = exports.Rules = void 0;

var _criteria = _interopRequireDefault(require("./criteria"));

var _criteriaConnect = _interopRequireDefault(require("./criteria-connect"));

var _criteriaHeader = _interopRequireDefault(require("./criteria-header"));

var _criteriaRule = _interopRequireDefault(require("./criteria-rule"));

var Rules = _interopRequireWildcard(require("./rules"));

exports.Rules = Rules;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

//
// Attach children to the main Component for availability without ES6 imports.
//
_criteria.default.Connect = _criteriaConnect.default;
_criteria.default.Header = _criteriaHeader.default;
_criteria.default.Rules = Rules;
_criteria.default.Rule = _criteriaRule.default; //
// Export the Class and related children.
//

var _default = _criteria.default;
exports.default = _default;